import React from 'react'
import { TOOLS_TEAM_IMAGE } from '../helpers/constants'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <div data-type='block-wrapper'>
      <div data-type='block' data-style='tools-team'>
        <div data-type='block-text'>
          <p data-type='block-title'>Powerful Tools and a Passionate Team</p>
          <p data-type='block-sub-text'>
            Spend less time managing logistics and more time making art.
          </p>
          <p data-type='block-sub-text'>
            <span>Painless shipping:</span> When you sell your art with Saatchi Art, shipping is
            paid for by the collector and is handled by our specialists, saving you time and money —
            you are only responsible for packaging the work and purchasing the packaging materials.
          </p>
          <p data-type='block-sub-text'>
            <span>Manage your portfolio anywhere:</span> Our Studio portfolio management tool allows
            you to add, edit and update artworks and respond to sales from anywhere.
          </p>
          <p data-type='block-sub-text'>
            <span>Display multiple images of your artwork:</span> Share up to 5 different viewpoints
            of each of your artworks, enabling Saatchi Art collectors to get a better sense of your
            work before purchase.
          </p>
          <p data-type='block-sub-text'>
            <span>Open Edition prints:</span> Earn additional income by allowing collectors to
            purchase open edition prints of your original artworks.
          </p>
          <p data-type='block-sub-text'>
            <span>Unique visuals:</span> Using the power of augmented reality, collectors can take
            advantage of our “View in Room” feature to see your artwork in their space before
            purchasing.
          </p>
        </div>
        <div data-type='block-image'>
          <picture data-type='image'>
            <img
              width='502'
              height='501'
              itemProp='image'
              src={TOOLS_TEAM_IMAGE}
              alt='hero'
              role='presentation'
              data-type='image'
            />
          </picture>
        </div>
      </div>
      <hr />
    </div>
  )
}

export default Component